import type { DSImage, DSUser } from '@/types'
import useStorageHelper from '@/composables/utils/useStorageHelper'

export default function useProfile() {
  const { getProfileImageUrl, getResizeUrl } = useStorageHelper()
  const getAvatarImage = (user: DSUser): DSImage | null => {
    return user.avatarImage ?? null
  }

  const getAvatarImageUrl = async (user: DSUser): Promise<string> => {
    if (!user)
      return ''
    const avatarImage = getAvatarImage(user)
    if (!avatarImage)
      return ''
    return getProfileImageUrl(user.id, avatarImage)
  }

  const getCoverImage = (user: DSUser): DSImage | null => {
    return user.coverImage ?? null
  }

  const getCoverImageUrl = async (user: DSUser): Promise<string> => {
    if (!user)
      return ''
    const coverImage = getCoverImage(user)
    if (!coverImage)
      return ''
    return getResizeUrl(coverImage, `users/${user?.id}`, coverImage.rawUrl)
  }

  return {
    getAvatarImage,
    getAvatarImageUrl,
    getCoverImage,
    getCoverImageUrl,
  }
}
